<template>
    <div id="app">
        <Menu v-if="menu" />
        <div class="body" :class="(menu ? 'menu' : '')" :style="(menu ? (pageShow ? 'left:300px; padding:0; width:calc(100% - 300px)' : 'left:0; padding:0 150px 0; width:100%') : '')" @scroll="handleScroll($event)">
        <!-- <div class="body" :class="menu ? 'menu' : ''"> -->
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Menu from "./components/Menu";
import bus from "./utils/bus.js";//导入中间件

export default {
    name: "App",
    computed: mapGetters(["menu"]),
    components: {
        Menu,
    },
    mounted(){
        this.checkLogin();
        // window.addEventListener('scroll', ()=>{
        //     if (document.documentElement.scrollTop
        //         + document.documentElement.clientHeight
        //         >= document.body.scrollHeight - 50) {
        //         // console.log(1111);
        //         bus.$emit("sendMessage",'123');
        //     }
        // });
        this.$get('api/mingcheng').then(res=>{
            this.$store.commit('SET', {mingcheng: res.data});
        })
    },
    methods: {
        handleScroll(e){
            let el = e.target
            //判断是否到达div容器底部
            if(el.scrollTop+el.clientHeight>=el.scrollHeight){
                bus.$emit("sendMessage",document.getElementsByClassName('body')[0]);
            }

        },
        checkLogin(){
            if(!this.isLogin()){
                let token = localStorage.getItem('token');
                if(token == '' || token == null){
                    // this.$router.push('/'); return;
                } else{
                    this.$store.commit('SET', {token: token});

                    this.$post('/api/my_info',{
                        token: token
                    }).then(res=>{
                        this.$store.commit('SET', {userInfo: res.data});
                    })
                    if(this.$route.path == '/'){
                        this.$router.push('/home');
                    }
                }
                    
                
            }
        }
    }
};
</script>

<style>
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    /* color: #000; */
    outline: none;
}
body {
    background: #f3f4f6;
    min-width:1920px;
    position: relative;
    overflow-y: hidden;

}
input{
    color:#333;
}
input::placeholder{
    color:#999;
}

.body{
    position: relative;
    overflow-y: auto;
    height:100vh;
    width:100%;
}
.body.menu{
    top:60px;
    left:300px;
    width:calc(100% - 300px);
    height:calc(100vh - 60px);
    transition: all .3s;
}





</style>



// WEBPACK FOOTER //
// src/App.vue